const sm2 = require('sm-crypto').sm2

// SM2 私钥（前端仅用于解密）
const PRIVATE_KEY = '0099e09909386c06e0f0d0e6646c4215a890a5d99e911842f6d2364925050f3bb3'

/**
 * SM2 解密
 * @param {string} cipherData 密文数据（hex 字符串）
 * @returns {string} 明文数据
 */
export function sm2Decrypt(cipherData) {
  if (!cipherData || cipherData === 'null' || cipherData === 'undefined') {
    return cipherData
  }
  try {
    // cipherMode = 1 表示 C1C3C2，与后端一致
    return sm2.doDecrypt(cipherData, PRIVATE_KEY, 1)
  } catch (e) {
    console.error('SM2 解密异常:', e)
    return cipherData
  }
}

/**
 * 对 /token/i 返回的用户数据解密敏感字段
 * @param {object} data 接口返回的 data 对象
 * @returns {object} 解密后的 data 对象
 */
export function decryptUserInfo(data) {
  if (!data) return data
  const result = { ...data }
  if (result.name) {
    result.name = sm2Decrypt(result.name)
  }
  if (result.papersnumber) {
    result.papersnumber = sm2Decrypt(result.papersnumber)
  }
  if (result.mobile) {
    result.mobile = sm2Decrypt(result.mobile)
  }
  if (result.cardid) {
    result.cardid = sm2Decrypt(result.cardid)
  }
  return result
}
